import { Base, getInstance } from "@studiometa/js-toolkit";
import { watchLayout, getLayout } from "../store/index.js";
const layouts = ["top", "right", "bottom", "left"];
class LayoutReactive extends Base {
  /**
   * Config.
   */
  static config = {
    name: "LayoutReactive",
    options: {
      top: String,
      right: String,
      bottom: String,
      left: String
    }
  };
  async mounted() {
    this.switch(await getLayout());
    return watchLayout((value) => {
      this.switch(value);
    });
  }
  switch(value) {
    this.$read(() => {
      let toAdd = "";
      let toRemove = "";
      layouts.forEach((layout) => {
        if (value === layout) {
          toAdd = this.$options[layout];
        } else if (this.$options[layout]) {
          toRemove += ` ${this.$options[layout]}`;
        }
      });
      toAdd = toAdd.trim();
      toRemove = toRemove.trim();
      if (toRemove.length) {
        this.$write(() => {
          this.$el.classList.remove(...toRemove.split(" "));
        });
      }
      if (toAdd.length) {
        this.$write(() => {
          this.$el.classList.add(...toAdd.split(" "));
        });
      }
      const maybeResizable = getInstance(this.$el, "Resizable");
      if (maybeResizable?.$isMounted) {
        maybeResizable.reset();
      }
    });
  }
}
export {
  LayoutReactive as default
};
//# sourceMappingURL=LayoutReactive.js.map
